import React, { useLayoutEffect, useEffect, useState, useRef,createRef} from "react";
import store from "@/redux/store";
import CommunicationCycleReducer, {getState, getTasks, saveTask, newTaskEvent, setChangedItems, setUpdate} from '@/reducers/CommunicationCycle';

import moment from 'moment';
import { Dialog, DialogBackdrop, DialogPanel, DialogTitle } from '@headlessui/react'
import {addCalenderItem, hideModal} from '@/reducers/ModalPopup';

import { ExclamationTriangleIcon } from '@heroicons/react/24/outline'
import BaseDialog from "@/components/dialog/BaseDialog";

export default function Store({...props}) {
    const confirmEvent = (event) =>  {
        if(props.modalOptions && props.modalOptions.action) {
            
            props.modalOptions.action(props.modalOptions);
        }
    }

   return (
        <>
 
<BaseDialog {...props} nofooter>
            <div className="sm:flex sm:items-start">
              <div className="mx-auto flex h-12 w-12 flex-shrink-0 items-center justify-center rounded-full bg-red-100 sm:mx-0 sm:h-10 sm:w-10">
                <ExclamationTriangleIcon aria-hidden="true" className="h-6 w-6 text-red-600" />
              </div>
              <div className="mt-3 text-center sm:ml-4 sm:mt-0 sm:text-left">
                <DialogTitle as="h3" className="text-base font-semibold leading-6 text-gray-900">
                  Opslaan contactblad
                </DialogTitle>
                <div className="mt-2">
                  <p className="text-sm text-gray-500">
                    Weet u zeker dat u het contactblad wilt opslaan?
                  </p>
                </div>
              </div>
            </div>
            <div className="mt-5 sm:mt-4 sm:flex sm:flex-row-reverse">
              <button
                type="button"
                onClick={() => confirmEvent(event)}
                className="inline-flex w-full justify-center rounded-md bg-red-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-red-500 sm:ml-3 sm:w-auto"
              >
                Opslaan
              </button>
              <button
                type="button"
                data-autofocus
                //onClick={() => setOpen(false)}
                className="mt-3 inline-flex w-full justify-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 sm:mt-0 sm:w-auto"
              >
                Annuleer
              </button>
            </div>
        </BaseDialog>
                          </>
        
    )
}